import React, { Component, PureComponent } from 'react'
import { View, Platform, StyleSheet} from 'react-native'
import {
	JDText, JDTouchable, JDImage,
	JDDevice, JDToast, JDModal, JDScrollView
} from '@jdreact/jdreact-core-lib'
import JDFollowingView from '@ares/jdreact-plugin-followbutton';
import getCity from '../../utils/lbs/index';
import PropTypes from 'prop-types'

import { 
	getAdsData, 
	getZufangAreaList,
	getZufangSearchCondition,
	getZufangSearchList
 } from '../../utils/api'
import { pt, isJDApp, isWX, isWQ, sendClickDataWithJsonParam, sendExposureData, sendPv, jumpByUrl } from '../../components/utiles';
import { isPhoneX, isHarmonyWeb, harmonyWebShare, isJDAppWebView } from "../../utils/tools";
import { NAVIGATION_BAR_HEIGHT, SYS_BAR_HEIGHT } from '../../utils/steep';
import { cacheUtil, CacheKeyEnum } from '../../utils/cacheManager';

import JDCNavigationBar from '../../components/JDCNavigationBar';
import SearchBanner from './components/searchBanner';
import BannerAds from './components/banner-ads';
import Banner from './components/banner';
import MaintabSearch from "./components/mainSearchBar"
import SearchPage from './components/searchPage';
import CityList from './components/cityList'
import FloatEntry from './components/floatEntry'
import HouseSourceItem from './components/houseItemCard'
import EmptyCard from './components/EmptyCard'
import FlatListFooter from '../../components/FlatListFooter'
import errpageImg from '../../images/detail/errpage.png'

const webModalBoxId = 'maintabsearchModal';
const isWeb = Platform.OS === 'web';
const Page_Id = 'OfficeBuilding_Home'
const justLiulanqiHead = isWeb ? ((isJDApp || isWX || isWQ) ? 0 : JDDevice.getRpx(88)) : NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT
let wrapperLayoutTop = 0

export const isEmptyObj = function(obj){
  if(typeof obj === 'undefined' || obj === null || obj === ''){
    return true
  } else {
    return false
  }
}

export default class ZufangIndex extends PureComponent{
	static contextTypes = {
		router: PropTypes.object
	};
	constructor(props) {
		super(props);

		this.state = {
			statusData: {
				isListFetching: false,  // 正在加载数据
				error: null,            // 出错
				firstGet: false,          // 在第一次数据请求返回之前，不设置加载圈
				hasNext: true, // 是否还有数据
				isLastPage: false // 是否是最后一页
			},
			recommendHouse: [],
			swiperDataList: [],
			bannerList:[],
			keyWord:'', // 搜索关键字
			cityInfo: {},
			searchObj:{},
			areaList: [],
			searchCondition:{},
			positionInfo: {},
			isPositionSucc: false,
			isTabSticky: false, // 筛选是否吸顶
			showPop: false, // 是否展示筛选弹层
			showPopSearch: false, // 是否展示搜索中间页
			isShowCityPicker: false, // 是否展示城市弹层
			isShowErrMsg: false, // 是否展示错误信息
			errMsg: "", // 提示的错误信息
			isErrPage: false,
			pageLoading: true
		};
		this.recommendHouseParams = {
			pageNo: 1,
			isLoading: false,
			noMoreData: false
		}
		this.pageScrollY = 0
		this.layoutData = [];
		// 已曝光的数据
		this.exposedList = [];
		this.pageSize = 10
		this.tabOffsetTop = 0; // 筛选栏的滚动距离
    this.tabHeight = 0; // 筛选栏的高度
		this.HeadTitleHeight = 0
		this.navBar = React.createRef();
		this.zufangPageScrollView = React.createRef();
		this.popSearchRef = React.createRef();
		this.tabBarRef = React.createRef();
		this.containerRef = React.createRef();
	}

	UNSAFE_componentWillMount(){
		if (isWeb && cacheUtil.getCacheFlag('_home')) {
			let cityInfo =cacheUtil.getCache(CacheKeyEnum.cityInfo_Home) || {};
			const {cityId} = cityInfo || {}
			if (cityId) {
				// 如果有城市缓存信息，先渲染轮播图、banner、无需走定位逻辑
				let isPositionSucc =cacheUtil.getCache(CacheKeyEnum.isPositionSucc_Home) || false;
				let swiperDataList = cacheUtil.getCache(CacheKeyEnum.swiperData_Home) || [];
				let bannerList =cacheUtil.getCache(CacheKeyEnum.bannerList_Home) || [];
				let positionInfo =cacheUtil.getCache(CacheKeyEnum.positionInfo_Home) || {};
					this.getLunboAndIconData(cityId)
					this.getAreaList(cityId)
					this.setState({
							swiperDataList,
							isPositionSucc,
							bannerList,
							positionInfo,
							cityInfo
					},()=>{
						sendPv({ pageId: Page_Id, pageParam: ''+cityId });
						this.getListData()
					})
			} else {
				this.getUserLocation()
			}
			cacheUtil.clearCacheFlag('_home')
		} else {
			this.getUserLocation()
		}
  }
	componentDidMount() {
		if (isWeb) {
			document.title = '京东写字楼'
			const { title, url, shareImg, content } = this.getShareContent()
			if (isJDAppWebView() && typeof JdShare !== 'undefined' && !isHarmonyWeb()) {
				JdShare.setShareInfo({
					title, url, shareImg, content,
					img: shareImg,
					channel: '',
					callback: null,
					clickcallback: null,
					qrparam: null,
					timeline_title: '',
				})
			}
			if (isHarmonyWeb()) {
				harmonyWebShare({
					title, url, shareImg, content
				})
			}
		}
		this.getConditionData()
		setTimeout(()=>{
			const visibleList = this._getVisibleItems();
			this._sendExpoData(visibleList);
		},100)
	}

	getUserLocation = () => {
		getCity().then(res => {
			this._changePositionInfo(res)
		}).catch(()=>{
			this._changePositionInfo({isPositionSucc: false,cityId:'', cityName: '', open: false, lat: '', lon: ''})
		});
	};

	_changePositionInfo = (res) => {
		const {isPositionSucc,cityId, cityName, open, lat, lon } = res
		const nowCityId = open ? cityId : 1
		const nowCityName = open ? cityName : '北京'
		this.getLunboAndIconData(nowCityId)
		this.getAreaList(nowCityId)
		this.setState({
				isPositionSucc,
				positionInfo: {
						cityId,
						cityName,
						open,
						lon,
						lat
				},
				cityInfo:{
					cityId: nowCityId,
					cityName: nowCityName
				}
		},()=>{
			sendPv({ pageId: Page_Id, pageParam: ''+this.state.cityInfo.cityId });
			this.getListData()
		})
	}

	/**
 * @description 处理页面滚动逻辑
 * @memberof Index
 */
	_handleScroll = ({
		nativeEvent: {
			contentOffset: { x, y },
			layoutMeasurement: { height: layoutHeight, width: layoutWidth },
			contentSize: { height, width }
		},
	}) => {
		// 横向滚动，也会触发该事件，要特殊处理一下
		if (isWeb && x > 0) return;

		if (this.state.showPop) {
			return false
		}
		this.pageScrollY = y
		if (isWeb) {
			if (y > (this.tabOffsetTop - this.HeadTitleHeight)  && !this.state.isTabSticky && this.tabOffsetTop !=0) {
				this.setState({
					isTabSticky: true
				});
			} else if (y < (this.tabOffsetTop - this.HeadTitleHeight) && this.state.isTabSticky) {
				this.setState({
					isTabSticky: false
				});
			} else {
			}
		} else {
			if (y > (this.tabOffsetTop - NAVIGATION_BAR_HEIGHT - SYS_BAR_HEIGHT)  && !this.state.isTabSticky) {
				this.setState({
					isTabSticky: true
				});
			} else if (y < (this.tabOffsetTop - NAVIGATION_BAR_HEIGHT - SYS_BAR_HEIGHT) && this.state.isTabSticky) {
				this.setState({
					isTabSticky: false
				});
			} else {
			}
		}

		if (y + layoutHeight >= (height - 20) && !this.recommendHouseParams.isLoading) {
			this.getListData()
		}

		const visibleList = this._getVisibleItems();
		this._sendExpoData(visibleList);

	}

	// 获取list
	getListData = () => {
		if (this.recommendHouseParams.noMoreData) {
			return false
		}
		const { keyWord, searchObj, cityInfo, positionInfo } = this.state
		const params = {
			...searchObj,
			title: keyWord,
			cityId: cityInfo.cityId,
			pageNum: this.recommendHouseParams.pageNo,
			pageSize: this.pageSize,
			longitude: positionInfo.lon || '',
			latitude: positionInfo.lat || '',
		}

		if (this.recommendHouseParams.pageNo === 1) {
			this.exposedList = [];
			this.layoutData = [];
		}

		this.recommendHouseParams.isLoading = true

		getZufangSearchList(params).then(res => {
			const { code, totalCount, data } = res || {}
			if (code === 0 && totalCount) {
				if (data && data.length > 0) {
					this.setState({
						recommendHouse: this.state.recommendHouse.concat(data)
					})
				}
				if (this.recommendHouseParams.pageNo * this.pageSize > totalCount) {
					this.setState({
						statusData: {
							isListFetching: false,
							error: null,
							firstGet: false,
							isLastPage: true,
							hasNext: false
						}
					});
					this.recommendHouseParams.noMoreData = true;
				} else {
					this.recommendHouseParams.noMoreData = false;
					this.setState({
						statusData: {
							isListFetching: false,
							error: null,
							firstGet: false,
							isLastPage: false,
							hasNext: true
						}
					});
				}
				this.recommendHouseParams.pageNo += 1;
			} else if (code === 0 && totalCount ==0) {
				// 没有搜索到房源
			}
			
			this.recommendHouseParams.isLoading = false;
		}).catch(err => {
			this.recommendHouseParams.isLoading = false;
			this.recommendHouseParams.noMoreData = false;
			this.setState({
				statusData: {
					isListFetching: false,
					error: null,
					firstGet: false,
					isLastPage: false,
					hasNext: true
				}
			});
		})
	};

getLunboAndIconData = (cityId) => {
	const lunboId = 2733 
	const bannerId = 2734
	const param = {param: [{ id: lunboId, num: -1, areaId: cityId },{ id: bannerId, num: -1 }]}
	this.setState({
		pageLoading: true
	})
	getAdsData(param).then((res) => {
			const { code, data, msg } = res
			if (code == 0) {
				if (data && data[lunboId] && data[lunboId].length > 0) {
					this.setState({
						swiperDataList: data[lunboId]
					})
				}
				if (data && data[bannerId] && data[bannerId].length > 0) {
					this.setState({
						bannerList: data[bannerId]
					})
				}
			}
			this.setState({
				pageLoading: false
			})
		})
		.catch((err) => {
			this.setState({
				pageLoading: false
			})
		});
}

getConditionData = () => {
	getZufangSearchCondition({}).then((res) => {
			const { code, data, msg } = res
			if (code == 0) {
				const nearL = res.nearbyCondition || []
				this.setState({
					searchCondition:{
						totalPriceList: res.totalPriceList || [],
						unitPriceList: res.unitPriceList || [],
						structureAreaList: res.structureAreaList || [],
						labelList: res.labelList || [],
						nearbyCondition: [{name:'全部',id:0}].concat(nearL)
					}
				})
			}
		})
		.catch((err) => {
		});
}

getAreaList = (cityId) => {
	const param = {secondCode: cityId}
	getZufangAreaList(param).then((res) => {
			const { code, citys, msg } = res
			if (code == 0 && citys && citys.length > 0) {
				const citysAll = [{thirdCode: 0, thirdName:'全部',childList:[]}]
				const allCity = citysAll.concat(citys)
				this.setState({
					areaList: allCity
				})
			} else {
				this.setState({
					areaList: []
				})
			}
		})
		.catch((err) => {
		});
}

searchParamsBack = (obj) => {
	const { searchObj } = this.state;
	const allParamsObj = Object.assign({}, searchObj, obj);
	Object.keys(allParamsObj).forEach(item => {
		if (isEmptyObj(allParamsObj[item])) {
			delete allParamsObj[item];
		}
	});
	if (JSON.stringify(allParamsObj) !== JSON.stringify(searchObj)) {
		this.exposedList = [];
		this.layoutData = [];
		this.recommendHouseParams = {
			pageNo: 1,
			isLoading: false,
			noMoreData: false
		}
		this.setState({
				searchObj: allParamsObj,
				recommendHouse: [],
				isTabSticky: false,
				statusData: {
					isListFetching: false,
					error: null,
					firstGet: false,
					isLastPage: false,
					hasNext: true
				}
		},() => {
			this.getListData()
		});
		this.zufangPageScrollView.current.scrollTo({
				x: 0,
				y: 1,
				animated: false
		});
		this.pageScrollY = 1
	}
}

inputGoSearch = (keyword) => {
	const { cityInfo} = this.state
	if(isWeb){
		if (!isJDApp) {
			this._handleBeforeJump()
		}
		this.setState({
			showPopSearch: false
		}, () => {
			const url = `https://esfr.m.jd.com/zufangList?cityId=${cityInfo.cityId}&cityName=${encodeURI(cityInfo.cityName)}&title=${encodeURI(keyword)}&routerName=zufangList`
			jumpByUrl(url)
		})
	}else{
		this.setState({
			showPopSearch: false
		}, () => {
			this.context.router['toZufangList']({
				title: encodeURI(keyword),
				cityId: cityInfo.cityId,
				cityName: encodeURI(cityInfo.cityName)
			});
		})
	}
}

	_onHide = () => { // 隐藏错误提示
		this.setState({
			errMsg: null,
			isShowErrMsg: false
		});
	};

	showErrFunc = (msg) => {
		this.setState({
			errMsg: msg,
			isShowErrMsg: true
		}, ()=> setTimeout(()=>{
			this._onHide()
		},3000))
	}
	showMainTabClick = (bool) => {
		if (isWeb) {
			this.tabBarRef.current.measure((fx, fy, width, height, px, py) => {
				this.tabHeight = height;
			});
		}
		if (bool) {
			setTimeout(()=>{
				if (this.zufangPageScrollView && this.zufangPageScrollView.current) {
					this.zufangPageScrollView.current.scrollTo({
						x: 0,
						y: isWeb ? this.tabOffsetTop - this.HeadTitleHeight -1 : this.tabOffsetTop - NAVIGATION_BAR_HEIGHT - SYS_BAR_HEIGHT,
						animated:true,
					});
				}
			}, 200)
		}

    this.setState({
      showPop: bool
    });
	}

	showMainTabClickTop = (bool) => {
    this.setState({
      showPop: bool
    });
	}

	_onTabBarLayout = ({
    nativeEvent: {
      layout: { y, height }
    }
  }) => {
    this.tabOffsetTop = y ;
		this.tabHeight = height;
  }

	_handleBeforeJump = () => {
		const {
			swiperDataList,
			bannerList,
			positionInfo,
			isPositionSucc,
			cityInfo
		} = this.state
		cacheUtil.setCache(CacheKeyEnum.swiperData_Home, swiperDataList);
		cacheUtil.setCache(CacheKeyEnum.bannerList_Home, bannerList);
		cacheUtil.setCache(CacheKeyEnum.positionInfo_Home, positionInfo);
		cacheUtil.setCache(CacheKeyEnum.isPositionSucc_Home, isPositionSucc);
		cacheUtil.setCache(CacheKeyEnum.cityInfo_Home, cityInfo);
		cacheUtil.setCacheFlag('_home');
  }
	_showSearchPage = () => {
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_SearchBox',
			page_id: Page_Id,
		})
    this.setState({
      showPopSearch: true
    })
	}
	_showCityPickerClick = () => {
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_CitySwitch',
      page_id: Page_Id,
			json_param: {
				cityid: this.state.cityInfo.cityId + ''
			},
		})
    this.setState({
      isShowCityPicker: true
    })
	}
	_deletWordFocus = () => {
		this.setState({
      showPopSearch: true
    }, ()=>{
        this.popSearchRef && this.popSearchRef.current && this.popSearchRef.current.deletWordFocus && this.popSearchRef.current.deletWordFocus();
    })
  }

	handleCityChange = (cityInfo) => {
		this.setState({
			cityInfo: cityInfo,
			isShowCityPicker: false,
			recommendHouse: [],
			keyWord: '',
			searchObj:{},
			isTabSticky: false
		},() => {
			// 一整个页面开始重新加载
			this.exposedList = [];
			this.layoutData = [];
			this.recommendHouseParams = {
				pageNo: 1,
				isLoading: false,
				noMoreData: false
			}
			this.setState({
				statusData: {
					isListFetching: false,
					error: null,
					firstGet: false,
					isLastPage: false,
					hasNext: true
				}
			});
			this.getLunboAndIconData(cityInfo.cityId)
			this.getAreaList(cityInfo.cityId)
			this.getListData()
		})
	}

	toZufangDetail= (skuId,index) => {

		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseResource',
			page_id: Page_Id,
			json_param: {
				skuid: skuId + '',
				sku_order: index + ''
			},
		})

		if(isWeb){
			if (!isJDApp) {
				this._handleBeforeJump()
			}
			this.setState({
			}, () => {
				const url = `https://esfr.m.jd.com/zufangDetail?skuId=${skuId}&routerName=zufangDetail`
			  jumpByUrl(url)
			})
		}else{
			this.context.router['toZufangDetail']({
				skuId: skuId
			});
		}
	}
	_separator() {
		return <JDText style={styles.rowLine}></JDText>
	}

	_scrollToTop = (animated = true) => {
    if (this.zufangPageScrollView && this.zufangPageScrollView.current) {
        this.zufangPageScrollView.current.scrollTo({
            x: 0,
            y: 0,
            animated,
        });
    }
	}

	/**
   * 过滤掉已经曝光过的数据
   */
  _filterUnExposedItems(dataList) {
		
		return dataList.filter(item => {
				return !this.exposedList.some(exposed => {
						return item.item.skuId === exposed.item.skuId;
				});
		}) || [];
	}
	_sendExpoData(dataList) {

		const itemsToExpo = this._filterUnExposedItems(dataList);
		
		if (itemsToExpo.length > 0) {
			console.log(itemsToExpo)
			this.exposedList = this.exposedList.concat(itemsToExpo);
			itemsToExpo.forEach(item => {
					sendExposureData({
						event_id: 'OfficeBuilding_HouseResource_expo',
						page_id: Page_Id,
						json_param: {
							skuid: item ? item.item.skuId + '' : '',
							sku_order: item.index + ''
						},
					})
			});
		}	
}
_getVisibleItems = () => {
	const viewportStart = Math.abs(wrapperLayoutTop - this.pageScrollY);
	const viewportEnd = JDDevice.height + this.pageScrollY;
	const visibleList = this.layoutData.filter(layoutItem => {
			const itemLayout = layoutItem.layout;
			if (itemLayout.top + itemLayout.height + wrapperLayoutTop > viewportStart && itemLayout.top + wrapperLayoutTop < viewportEnd) {
					return true;
			}
			return false;
	});
	return visibleList;
}
_onWrapperLayout = (e) => {
	this.containerRef.current && this.containerRef.current.measure && this.containerRef.current.measure((fx, fy, w, h, px, py) => {
		wrapperLayoutTop = Math.max(wrapperLayoutTop, py);
	});
};
_onItemContainerLayout = (e, item, index) => {
	const containerLayout = e.nativeEvent.layout;
	this.layoutData.push({
		layout: { ...containerLayout, ...{ top: containerLayout.y } },
		item: item,
		index: index
	});
};

getShareContent = () => {
	return {
		title: '京东写字楼，京选好房源',
		url: 'https://esfr.m.jd.com/zufang',
		shareImg: 'https://misc.360buyimg.com/business/house/static/img/sharelogo.png',
		content: '多房源，快咨询，好品质，低价格',
	}
}

	render() {
		let {
			keyWord,
			isErrPage,
			searchCondition,
			areaList,
			searchObj,
			cityInfo,
			isTabSticky,
			showPopSearch,
			bannerList,
			swiperDataList,
			isShowCityPicker,
			positionInfo,
			isPositionSucc,
			recommendHouse,
			pageLoading
		} = this.state;
		let titleName = '京东写字楼';
	
		return (
			<View style={styles.page}>
				<JDCNavigationBar
					renderMiddle={() => <View style={styles.navMiddBox}>
						<JDText style={styles.navMiddText}>{ titleName }</JDText>
						<View style={styles.navShareView}>
							<JDFollowingView channelId={'CA041817061091980895'} buttonStyleType={'black'} />
						</View>
					</View>}
					hasShare={true}
					showMoreButton={true}
					containerStyle={{}}
					barContainerStyle={{ backgroundColor: '#f6f6f6' }}
					bgStyle={{ backgroundColor: '#f6f6f6' }}
					ref={this.navBar}
					theme={'dark'}
				/>
				
				{isErrPage&& <View style={styles.errpageBox}>
					<View>
						<JDImage
							style={styles.errpageImg}
							source={errpageImg}
						></JDImage>
					</View>
					<JDText style={styles.errpageText}>当前活动太火爆啦！请稍后重试！</JDText>
					<JDText style={styles.errpageTip}>请点击按钮重新加载</JDText>
					<JDTouchable onPress={null}>
						<View style={styles.errpageBtn}>
							<JDText style={styles.errpageBtnText}>重新加载</JDText>
						</View>
					</JDTouchable>
				</View>}

				<JDScrollView
          scrollEnabled={true}
          showsVerticalScrollIndicator={false}
          style={[ styles.scrollContainer, (isErrPage ? {'display':'none'} : null )]}
          scrollToTop={true}
          overScrollMode={'never'}
          bounces={false}
					ref={this.zufangPageScrollView}
          scrollEventThrottle={16}
          onScroll={this._handleScroll}
          onScrollEndDrag={this._handleScroll}
          onMomentumScrollEnd={this._handleScroll}
          optimizedMode
        >
						<View style={styles.barMeBox}></View>
						{/* 搜索框 */}
						<SearchBanner
								customStyle={{
										width: JDDevice.getRpx(702),
										marginTop: JDDevice.getRpx(28),
										marginBottom: JDDevice.getRpx(28),
								}}
								showCityPickerClick={this._showCityPickerClick}
								cityName={cityInfo.cityName}
								placeholder={'请输入楼盘/商圈'}
								keyword={keyWord}
								deletWordFocus={this._deletWordFocus}
								search={this._showSearchPage}
						/>

						{/* 轮播图 */}
						{pageLoading || (swiperDataList.length < 1) ? <View style={styles.lunbo_zhanwei}></View> :<BannerAds
               style={{
                   marginBottom: pt(23)
               }}
               pageId={Page_Id}
               eventId={''}
               jsonParams={{}}
               ext={{}}
               mtaIndexName=''
							 isLoop= {true}
							 autoPlay={true}
							 cityId={cityInfo.cityId}
               onBeforeJump={(isWeb && !isJDApp) ? this._handleBeforeJump : null}
               bannerList={swiperDataList}
               activityLogoUrl={''}
               direction={'horizontal'} />}

						{/* 金刚区 */}
						{pageLoading  ? <View style={styles.banner_zhanwei}></View> : (bannerList.length > 2 ? <View style={styles.bannerWrap}>
						<Banner
								itemTextStyle={{
									fontWeight: 'bold',
									fontSize: pt(24)
								}}
								pageId={Page_Id}
								bannerList={bannerList}
								limitNum={5}
								onBeforeJump={(isWeb && !isJDApp) ? this._handleBeforeJump : null}
							/></View> : null)}

							{/* 筛选框 */}
						<View onLayout={(e) =>this._onTabBarLayout(e)} ref={this.tabBarRef} style={{ zIndex: 101, marginTop: -2 }}>
								<MaintabSearch
									customStyle={{ borderRadius: pt(12) }}
									showMainTabClick={this.showMainTabClickTop}
									talkParams={this.searchParamsBack}
									webModalBoxId={webModalBoxId}
									pageId={Page_Id}
									showNear={isPositionSucc && positionInfo.cityId == cityInfo.cityId}
									tabBarCustomStyle={{}}
									fristCode={cityInfo.cityId}
									areaList={areaList}
									NearList={searchCondition.nearbyCondition}
									searchObj={searchObj}
									priceObj={
										{totalPriceList: searchCondition.totalPriceList,
										unitPriceList: searchCondition.unitPriceList}
									}
									mainjiList={searchCondition.structureAreaList}
									typeList={searchCondition.labelList}
									//pageScrollY= {isWeb? this.tabHeight + this.HeadTitleHeight : (NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT + this.tabHeight)} 
								/>
						</View>
							{/*房源列表*/}
							{
								recommendHouse && recommendHouse.length > 0 && (
									<View style={styles.houseSourceContainer}>
										<View style={[styles.houseSourceCon,{ marginBottom: JDDevice.getRpx(15) }]} ref={this.containerRef} onLayout={this._onWrapperLayout}>
										{
												recommendHouse.map((item, index) => {
													return <View key={index+'_flatlistitem_index'} onLayout={(event) => this._onItemContainerLayout(event, item, index)}><JDTouchable onPress={() => this.toZufangDetail(item.skuId, index)}>
													<HouseSourceItem pageId={Page_Id} recommendHouseItem={item} index={index} ></HouseSourceItem>
												</JDTouchable></View>
												})
											}
											<FlatListFooter data={this.state.statusData}/>
										</View>
									</View>
								)
							}
							{
								recommendHouse.length === 0 && (
									<View style={styles.houseSourceContainer}>
										<EmptyCard textOne={'没有找到合适的房源'} textTwo={'换个条件试试'}></EmptyCard>
									</View>
								)
							}
				</JDScrollView>
				
				{/* 吸顶筛选框 */}
        {isTabSticky ? <View style={styles.isXiding_normal}>
          <View style={{ zIndex: 101 }}>
            <MaintabSearch
              customStyle={{ borderRadius: pt(12) }}
							showMainTabClick={this.showMainTabClickTop}
              talkParams={this.searchParamsBack}
              webModalBoxId={webModalBoxId}
              pageId={Page_Id}
							showNear={isPositionSucc && positionInfo.cityId == cityInfo.cityId}
							tabBarCustomStyle={{}}
							fristCode={cityInfo.cityId}
							searchObj={searchObj}
							areaList={areaList}
							NearList={searchCondition.nearbyCondition}
							priceObj={
								{totalPriceList: searchCondition.totalPriceList,
								unitPriceList: searchCondition.unitPriceList}
							}
							mainjiList={searchCondition.structureAreaList}
							typeList={searchCondition.labelList}
              // pageScrollY={100}
            />
          </View>
        </View> : null}

				{/* 搜索中间页 */}
				<JDModal visible={showPopSearch} transparent={true}>
						<View style={styles.popSearchView}>
								{
									<JDCNavigationBar
										beforeBack={()=>{
											this.setState({
												showPopSearch: false
											});
										}}
										renderMiddle={() => <View style={styles.navMiddBox}><JDText style={styles.navMiddText}>{ '搜索' }</JDText></View>}
										showMoreButton={false}
										containerStyle={{}}
										barContainerStyle={{ backgroundColor: 'transparent' }}
										bgStyle={{}}
										theme={ 'dark'}
									/>
								}
									<SearchPage
											ref={this.popSearchRef}
											goSearchKeyword={this.inputGoSearch}
											placeholder={'请输入楼盘/商圈'}
											keyword={keyWord}
											cityName={cityInfo.cityName}
											cityId={cityInfo.cityId}
											pageId={'OfficeBuilding_SearchList'}
											isIconShow={isWeb ? false : true}
											beforeBack={()=>{
												this.setState({
													showPopSearch: false
												})
											}}
											searchPageViewStyle={{paddingLeft: JDDevice.getRpx(32)}}
									/>
						</View>
				</JDModal>

				{/* 城市选择组件 */}
        <JDModal visible={isShowCityPicker} transparent={true}>
          <View style={styles.cityListPop}>
						{
							<JDCNavigationBar
								beforeBack={()=>{
									this.setState({
										isShowCityPicker: false
									});
								}}
								renderMiddle={() => <View style={styles.navMiddBox}><JDText style={styles.navMiddText}>{ '选择城市' }</JDText></View>}
								showMoreButton={false}
								containerStyle={{}}
								barContainerStyle={{ backgroundColor: 'transparent' }}
								bgStyle={{}}
								theme={ 'dark'}
							/>
						}
            <CityList
							changePositionInfo={this._changePositionInfo}
							changeCityClick={this.handleCityChange}
							positionInfo={positionInfo}
							isPositionSucc={isPositionSucc}
							pageCityId={cityInfo.cityId}
						/>
          </View>
        </JDModal>
				{ isTabSticky && <FloatEntry
                    iconUrl="https://img14.360buyimg.com/imagetools/jfs/t1/181974/22/28618/593/6316b699E492ad966/762dd3c069e215ba.png"
                    onPress={this._scrollToTop}/>
        }
				{
					isPhoneX() && (<View style={styles.iphoneXDiv} />)
				}
				{/*错误信息提示模块*/}
				<JDToast show={this.state.isShowErrMsg} onHide={this._onHide} style={styles.toastStyle} mode={JDToast.MODE.MODAL}>
					{this.state.errMsg}
				</JDToast>
				{
						isWeb && <div id="maintabsearchModal"></div>
				}
			</View>
		)
	}
}

const styles = StyleSheet.create({
  page: {
		position: 'relative',
		backgroundColor: '#f6f6f6',
		flex: 1,
	},
	navShareView: {
		position: 'absolute',
		top: pt(26),
		right: 0,
	},
	scrollContainer: {
		flex: 1,
		overflow: 'visible',
		paddingHorizontal: pt(24)
	},
	lunboWarp: {
		backgroundColor: '#ffffff',
		marginBottom: pt(22),
		height: pt(264),
		borderRadius: pt(18)
	},
	bannerWrap: {
		backgroundColor: '#ffffff',
		marginBottom: pt(10),
		paddingVertical: pt(30),
		borderRadius: pt(24)
	},
	lunbo_zhanwei: {
		backgroundColor: '#ffffff',
		height: pt(264),
		marginBottom: pt(20)
	},
	banner_zhanwei: {
		backgroundColor: '#ffffff',
		marginBottom: pt(10),
		paddingVertical: pt(30),
		borderRadius: pt(24),
		minHeight: pt(170)
	},
	// 推荐房源
	houseSourceContainer: {
		// minHeight: pt(1500)
	},
	houseSourceCon: {
		backgroundColor: "#fff",
		paddingBottom: JDDevice.getRpx(12),
		marginBottom: JDDevice.getRpx(24),
		borderRadius: JDDevice.getRpx(24),
	},
	toastStyle: {
		backgroundColor: "rgba(0,0,0,0.6)"
	},
	image: {
		width: JDDevice.width,
		height: JDDevice.getRpx(420),
		resizeMode: 'stretch'
	},
	brokerFooter: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 2,
		height: JDDevice.getRpx(150),
		width: JDDevice.getRpx(750),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: '#fff',
		borderTopLeftRadius: JDDevice.getRpx(48),
		borderTopRightRadius: JDDevice.getRpx(48),
		paddingHorizontal: JDDevice.getRpx(36),
		paddingTop: JDDevice.getRpx(30),
		...Platform.select({ // 不同的平台执行不同的阴影样式
			ios: {
				shadowColor: '#000',
				shadowOffset: { h: 0, w: JDDevice.getRpx(10) }, // ios设置阴影
				shadowOpacity: 0.05
			},
			web: {
				boxShadow: '0 -3px 10px rgba(0,0,0,0.05)'
			}
		}),
	},

	iphoneXDiv: {
		width: JDDevice.getRpx(750),
		height: 17,
		backgroundColor: '#F0F2F5'
	},
	paddingDiv: {
		marginHorizontal: JDDevice.getRpx(24),
	},
	skeletonpageBox:{
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%',
		overflow:'hidden'
	},
	skeletonImg:{
		width: '100%',
		height:'100%',
	},
	errpageBox: {
		position: 'absolute',
		top: NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%'
	},
	errpageImg: {
		width: JDDevice.getRpx(378),
		height: JDDevice.getRpx(392),
	},
	errpageText: {
		fontSize: JDDevice.getRpx(32),
		color: '#808080',
		paddingVertical: JDDevice.getRpx(6),
	},
	errpageTip: {
		fontSize: JDDevice.getRpx(26),
		color: '#808080',
	},
	errpageBtn: {
		width: JDDevice.getRpx(200),
		height: JDDevice.getRpx(88),
		borderRadius: JDDevice.getRpx(44),
		borderColor: '#FA2C19',
		borderWidth: JDDevice.getDpx(1),
		marginTop: JDDevice.getRpx(44),
		justifyContent: 'center'
	},
	errpageBtnText: {
		fontSize: JDDevice.getRpx(34),
		color: '#FA2C19',
		textAlign: 'center'
	},
	navMiddBox: {
		width: '100%',
		height: JDDevice.getRpx(88),
		justifyContent: 'center',
		alignItems: 'center'
	},
	navMiddText: {
		fontSize: JDDevice.getRpx(32),
		color: '#2E2D2D',
	},
	barMeBox: {
    width: JDDevice.width,
    height: justLiulanqiHead,
		backgroundColor: '#f6f6f6'
  },
	isXiding_normal: {
    zIndex: 500,
    position: 'absolute',
    top:  justLiulanqiHead,
    width: JDDevice.width,
		paddingHorizontal: pt(24)
  },  
	popSearchView: {
		width: JDDevice.width,
		height: JDDevice.height + SYS_BAR_HEIGHT,
		backgroundColor: '#f6f6f6',
	},
	cityListPop: {
		width: '100%',
    height: '100%',
    backgroundColor: '#fff'
	},
});
module.exports = ZufangIndex;